import type {CommonProps} from './types';

export default ({color = '#58595B', size = 24, ...rest}: CommonProps) => (
  <svg aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    height={size}
    width={size}
    {...rest}
  >
    <g transform="scale(2)">
      <path
        d="M21.75 5.25H13.5a3 3 0 0 0-3 3V12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m17.25 9.75 4.5-4.5-4.5-4.5"
      />
      <path
        d="M18.75 14.25v7.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5H6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);
